import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/app.css';
import BackToTop from 'vue-backtotop';


// // Analytics
// import VueMatomo from "vue-matomo";
// import Vue from "vue";

const feather = require('feather-icons');
feather.replace();

createApp(App)
	.use(router)
	.use(BackToTop)
	.mount('#app');

const appTheme = localStorage.getItem('theme');

// Check what is the active theme
if (
	appTheme === 'dark' &&
	document.querySelector('body').classList.contains('app-theme')
) {
	document.querySelector('body').classList.add('bg-primary-dark');
} else {
	document.querySelector('body').classList.add('bg-secondary-light');
}



// Vue.use(VueMatomo, {
//   host: "https://vueportfolio.matomo.cloud/", // switch this to your account
//   siteId: 2,                            // switch this as well you can find the site id after adding the website to the dashboard. 

//   router: router,

//   enableLinkTracking: true,

//   requireConsent: false,

//   trackInitialView: true,

//   trackerFileName: "piwik",

//   debug: true
// });